import appReducer from './reducers/reducer'
import { createStore } from 'redux'

export default () => {
    return createStore(appReducer, {
        formulas: {
            solidRate: {

            },
            atomicMass: {

            },
            densityCorrection: {

            },
            unitConverter: {

            },
            processYield: {

            },
            so3Correction: {

            },
            propertyTable: {
                
            }
        }
    })
}